import { DeviceType } from '@/src/types'
import { getAppAgent, isEmpty } from '@/src/utils/helper'
import { logError } from '@/src/utils/logError'
import { VISA_ERRORS, AUTH_ERRORS, ERROR_MESSAGES } from '@/src/constants/error'
import axios from 'axios'

export const apiPutOrPostHelper = async ({
    URL = '',
    payload = {},
    contentType = '',
    requestHeaders = {},
    method = 'post',
    deviceType,
    skipErrorHandling = false
}: {
    URL: string
    payload?: object
    contentType?: string
    requestHeaders?: object
    method?: string
    deviceType: DeviceType
    skipErrorHandling?: boolean
}) => {
    try {
        const appAgent = getAppAgent(deviceType)
        let headers = {
            Accept: 'application/json',
            'Content-Type': '',
            X_CT_SOURCETYPE: 'MOBILE',
            'app-agent': appAgent,
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: '0'
        }

        // This allows the browser to set it with the correct boundary parameter for FormData objects
        if (!(payload instanceof FormData)) {
            let contentTypeText = 'application/json'
            if (contentType) {
                contentTypeText = contentType
            }
            headers['Content-Type'] = contentTypeText
        }

        if (typeof window !== 'undefined') {
            headers = { ...headers, ...window.androidData, ...window.iosData }
        }

        if (!isEmpty(requestHeaders)) {
            headers = {
                ...headers,
                ...requestHeaders
            }
        }

        let responseData

        if (method === 'post') {
            responseData = await axios.post(URL, payload, {
                headers
            })
        } else {
            responseData = await axios.put(URL, payload, {
                headers
            })
        }

        return responseData
    } catch (e) {
        logError('apiPutOrPostHelper', e)
        return e
    }
}
